import { TaskSelectionFilters } from 'app/modules/selection-generic/entities/task-search-modal';

export class ChangeTaskModel {
    constructor(
        public Tipo?: number,
        public Fecha?: string,
        public Tarea1?: string,
        public TipoAutor?: string,
        public Autor?: string,
        public MedicoId?: number,
        public TasksResults?: TaskSelectionFilters,
    ) { }
}